import { ResourceType } from "@core/shared/types";
import {
  AudioIcon,
  FileIcon,
  FileTextIcon,
  ImageIcon,
  VideoIcon,
} from "@design-system/components/Icons";

export function useResourceIcon() {
  const getResourceIcon = (type: ResourceType) => {
    switch (type) {
      case ResourceType.Pdf:
      case ResourceType.Docx:
      case ResourceType.Xlsx:
      case ResourceType.Pptx:
        return <FileTextIcon className="h-5 w-5" />;
      case ResourceType.Image:
        return <ImageIcon className="h-5 w-5" />;
      case ResourceType.Video:
        return <VideoIcon className="h-5 w-5" />;
      case ResourceType.Audio:
        return <AudioIcon className="h-5 w-5" />;
      default:
        return <FileIcon className="h-5 w-5" />;
    }
  };

  return {
    getResourceIcon,
  };
}
